export const ASHBY_INTERNAL_EMPLOYEE_TEXTS = {
    trigger: "Employee at monday.com?",
    modalTitle: "Employee at monday.com?",
    modalBodyPrefix: "If you want to send a referral or explore internal opportunities ",
    modalCta: "Click here",
    closeAriaLabel: "Close"
};
